import * as type from '@app/constants/myDevices/twrDevices'

export const getTwrHealth = (id: number) => ({
  type: type.GET_TWR_HEALTH,
  id,
} as const)
